const AUDIO_TRANSFER_TYPES_LIST_DATA = {
  titleData: {
    textList: [
      {
        id: 1,
        text: '',
        textMob: '',
        secondText: 'All Types of Audio Media',
        secondTextMob: 'All Types of',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: true,
        isLeftMob: true,
        isRight: false,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: false,
        isTextWithLineMob: false,
        isSecondTextWithLine: true,
        isSecondTextWithLineMob: true,
        firstTextLines: [],
        secondTextLines: [{
          id: 1,
          isLeftLine: false,
          isRightLine: true,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: true,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#fff',
          isLineWithSquareMob: true,
        }],
      },
      {
        id: 2,
        text: 'Converted to Digital.',
        textMob: 'Audio Media.',
        secondText: '',
        secondTextMob: '',
        isTextReverse: false,
        isTextReverseMob: false,
        isTextColumn: false,
        isTextColumnMob: false,
        isLeft: false,
        isLeftMob: true,
        isRight: true,
        isRightMob: false,
        color: '#fff',
        colorMob: '#fff',
        isTextWithLine: true,
        isTextWithLineMob: false,
        isSecondTextWithLine: false,
        isSecondTextWithLineMob: false,
        firstTextLines: [{
          id: 1,
          isLeftLine: true,
          isRightLine: false,
          isTopLine: false,
          isBottomLine: false,
          color: '#fff',
          isLineWithSquare: false,
          isLeftLineMob: false,
          isRightLineMob: true,
          isTopLineMob: false,
          isBottomLineMob: false,
          colorMob: '#5F8AA4',
          isLineWithSquareMob: true,
        }],
        secondTextLines: [],
      },
    ],
  },
  typesList: [
    {
      id: 1,
      title: 'Audio Cassettes',
      description: 'Convert your cassette tapes to high-quality digital audio files.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 2,
      title: 'Audio Reels',
      description: 'Professional reel-to-reel audio tape transfer with studio-grade equipment.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 3,
      title: 'Vinyl Records',
      description: 'Digitize your vinyl LP records and preserve your music collection forever.',
      image: '',
      imageMob: '',
      link: '',
    },
    {
      id: 4,
      title: 'Micro Cassettes',
      description: 'Transfer micro cassette recordings to digital with complete clarity.',
      image: '',
      imageMob: '',
      link: '',
    },
  ],
};

export default AUDIO_TRANSFER_TYPES_LIST_DATA;
